/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const candidateExportLogStatusSchema = z.enum(['completed', 'failed'])

export type CandidateExportLogStatusSchema = z.infer<typeof candidateExportLogStatusSchema>
